import { access } from "fs";
import { getSubLevelInt, getSubLevelString } from "../util/general_util";
import { Trip_v2 } from "../util/tripPlanner_types";

export function check_addStay_access(trip:Trip_v2) {
    const subLevel:number = getSubLevelInt();
    const subLevelString:string = getSubLevelString();
    let popupAttr:string;
    if (subLevel > -1) {
		popupAttr = 'freemiumShowSubscribe';
	} else {
		popupAttr = 'freemiumShowSignup';
	};
    let addStayMinAccessLevel: number
	let addStayMaxAmount: string|number
	if (window.featureFlags.freemiumAccess == false || window.featureFlags.freemiumAccess.off == true) {
		addStayMinAccessLevel = 0
		addStayMaxAmount = "inf"
	} else {
		addStayMinAccessLevel = window.featureFlags.freemiumAccess.staySelection.addCampground;
		addStayMaxAmount = window.featureFlags.freemiumAccess.staySelection.addLimit[subLevelString];
	};

    if (addStayMinAccessLevel > subLevel + 1) {
        return {
            access: false,
            accessLvl: addStayMinAccessLevel,
            popupAttr: popupAttr
        };
    };

    let addStayAccess:boolean = true;

    if (addStayMaxAmount != "inf") {
        let count:number = 0;
        window.tripPlannerCurrentTrip.legs.forEach(leg => {
			leg.clusters.forEach(cluster => {
				count += cluster.selectedCamps.length
			});
		});

        if(count >= (addStayMaxAmount as number)){
			if(subLevelString == "anonymous"){
				addStayAccess = false;
			} else if (subLevelString == "member"){
				addStayAccess = false;
			};
		};
    };

    if (!addStayAccess) {
        return {
            access: false,
            accessLvl: addStayMinAccessLevel,
            popupAttr: popupAttr
        };
    };

    return {
        access: true,
        accessLvl: addStayMinAccessLevel,
        popupAttr: ""
    };
};